




import Vue from 'vue';
import importantInformationSelectOrganization from '@/components/important-information/important-information-select-organization.component.vue';

export default Vue.extend({
  components: {
    'important-information-select-organization': importantInformationSelectOrganization,
  },
});
